export default __webpack_public_path__ + "static/media/clients-empty.c565754e.svg";